import { render } from "./settings_user_management_table.html?vue&type=template&id=5b1359d0&external"
import script from "./settings_user_management_table.js?vue&type=script&lang=js&external"
export * from "./settings_user_management_table.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__